// removed by extract-text-webpack-plugin
module.exports = {"day":"DayScheduleView__day___2YfLK","slots":"DayScheduleView__slots___2uJ4F","weekday":"DayScheduleView__weekday___1djW0"};